var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVn = function SvgVn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#VN_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 43C33.374 43 43 33.374 43 21.5S33.374 0 21.5 0 0 9.626 0 21.5 9.626 43 21.5 43Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.5 11.218 2.32 7.141h7.51l-6.075 4.413 2.32 7.142L21.5 25.5l-6.074 4.414 2.32-7.142-6.075-4.413h7.509l2.32-7.141Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "VN_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h43v43H0z"
  })))));
};
export default SvgVn;